<template>
  <div style="width:100%">
    <tab-bar :visiblePlaceholder="false" @anchorPoint="anchorPoint" />
    <div ref="home"></div>
    <Carousel />
    <div class="new-content" ref="indexCompanyProfile">
      <p>COMPANY PROFILE</p>
      <h3>公司简介</h3>
      <div class="ql-editor">
        <div v-html="companyProfile.word"></div>
      </div>
    </div>
    <!-- 平台信息 -->
    <div class="new-content" ref="indexPlatformInfo">
      <p>PLATFORM INFORMATION</p>
      <h3>平台信息</h3>
      <PlatformInfo />
    </div>
    <!-- 新闻 -->
    <div class="news" ref="indexNews">
      <info :dataList="newsList">
        <template v-slot:title>
          <p>NEWS</p>
          <h3>新闻动态</h3>
        </template>
      </info>
      <el-button
        type="text"
        @click="$router.push({ path: '/article', query: { type: 'NEWS' } })"
        >查看更多+</el-button
      >
    </div>
    <!-- 政策法规 -->
    <div class="policies" ref="indexPolicies">
      <info :dataList="policiesList">
        <template v-slot:title>
          <p>Policies and regulations</p>
          <h3>政策法规</h3>
        </template>
      </info>
      <el-button
        type="text"
        @click="$router.push({ path: '/article', query: { type: 'Policies' } })"
        >查看更多+</el-button
      >
    </div>
  </div>
</template>
<script>
import info from "@/components/index/info";
import tabBar from "@/components/index/tabbar";
import utils from "@/utils";
import Carousel from "@/components/index/carousel";
import { mapState } from "vuex";
import PlatformInfo from "@/components/index/platformInfo.vue";
export default {
  components: {
    tabBar,
    Carousel,
    PlatformInfo,
    info
  },
  data() {
    return {
      supplyList: [], //推荐货源列表
      routeList: [], //推荐路线列表
      carList: [], //推荐车源列表
      type: "", //1：上年运量 2:上年本月 3:本年本月
      tableData: {}, //tableList对象
      tableList: [], //tableList列表
      btnArr: [
        { type: "1", title: "上年运量" },
        { type: "2", title: "上年本月" },
        { type: "3", title: "本年本月" }
      ],
      // 新闻列表
      newsList: [],
      //政策法规列表
      policiesList: [],
      //政策法规列表
      regulationsList: [],
      transactionInfo: {
        tradeNum: 0,
        tradeMoney: 0,
        carRegisterNum: 0,
        goodsTypeNum: 0
      },
      time: 3000,
      companyProfile: {
        //公司简介
        word: ""
      },
      activeId: 1, // 默认选中
      scrollTop: 0,
      timer: null,
      scrollBottom: 0
    };
  },
  computed: {
    ...mapState(["isLogin"])
  },
  watch: {
    isLogin() {
      this.getCarList();
    }
  },
  methods: {
    windowScroll() {
      this.scrollTop = document.documentElement.scrollTop;
      this.scrollBottom =
        document.documentElement.scrollHeight -
        document.documentElement.scrollTop -
        document.documentElement.clientHeight;
      if (this.scrollBottom < 100) {
        clearInterval(this.timer);
      }
    },
    anchorPoint(pointId) {
      clearInterval(this.timer);
      if (!pointId) {
        document.documentElement.scrollTop = 0;
        return false;
      }
      let offsetTop = this.$refs[pointId].offsetTop;
      this.timer = setInterval(() => {
        this.scrollTopTimer(offsetTop - 120);
      }, 20);
      // document.documentElement.scrollTop = offsetTop - 120;
    },
    scrollTopTimer(offsetTop) {
      let scrollTop = this.scrollTop;
      if (offsetTop > scrollTop) {
        scrollTop += 200;
        if (scrollTop >= offsetTop) {
          scrollTop = offsetTop;
          clearInterval(this.timer);
        }
      } else {
        scrollTop -= 200;
        if (scrollTop <= offsetTop) {
          scrollTop = offsetTop;
          clearInterval(this.timer);
        }
      }
      document.documentElement.scrollTop = scrollTop;
    },
    // 获取货源列表
    getSupplyList() {
      this.$http
        .supplyList({
          pageNum: 1,
          pageSize: 3,
          demandOrderStatus: "调度中"
        })
        .then(res => {
          if (
            res.data.code == 200 &&
            res.data.success &&
            res.data.data &&
            Array.isArray(res.data.data)
          ) {
            this.supplyList = res.data.data;
            // this.total = res.data.page.count;
            this.supplyList.forEach(item => {
              item.loadStartTime = utils.formattingDate(
                item.loadStartTime
              ).second;
              item.loadEndTime = utils.formattingDate(item.loadEndTime).second;
            });
          } else {
            this.supplyList = [];
          }
        });
    },
    getRouteList() {
      this.$http
        .routeList({
          pageNum: 1,
          pageSize: 3
        })
        .then(res => {
          if (
            res.data.code == 200 &&
            res.data.success &&
            Array.isArray(res.data.data.data)
          ) {
            this.routeList = res.data.data.data;
            this.total = res.data.data.total;
            this.routeList.forEach(item => {
              item.routeStartTime = utils.formattingDate(
                item.routeStartTime
              ).second;
            });
          } else {
            this.routeList = [];
          }
        });
    },
    getCarList() {
      this.$http
        .emptyCarList({ pageNum: 1, pageSize: 4, keyword: "PASS" })
        .then(res => {
          if (
            res.data.code == 200 &&
            res.data.success &&
            Array.isArray(res.data.data.data)
          ) {
            this.carList = res.data.data.data;
          } else {
            this.carList = [];
          }
        });
    },
    // 初始化-滚动table的btn默认选中的样式。
    initbtn() {
      this.type = "1";
    },
    // table列表
    btnChange(type) {
      this.type = type;
      switch (type) {
        case "1":
          this.tableList = this.tableData.lastYear;
          break;
        case "2":
          this.tableList = this.tableData.lastMonth;
          break;
        case "3":
          this.tableList = this.tableData.month;
          break;
      }
    },
    getTableList() {
      this.$http.getTrafficInfo().then(res => {
        if (res.data.code === 200 && res.data.success) {
          this.tableData = res.data.data;
          this.tableList = res.data.data.lastYear;
        }
      });
    },
    getHomeInfo() {
      this.$http.getHomeInfo().then(res => {
        if (res.data.code == 200 && res.data.success) {
          this.transactionInfo = res.data.data;
        }
      });
      this.$http
        .getArticleList({ pageNum: 1, pageSize: 6, type: "NEWS" })
        .then(res => {
          if (res.data.code == 200 && res.data.success) {
            this.newsList = res.data.data.list;
            this.newsList.forEach(item => {
              item.publishTime = utils.formattingDate(item.publishTime).second;
            });
          }
        });
      this.$http
        .getArticleList({ pageNum: 1, pageSize: 6, type: "Policies" })
        .then(res => {
          if (res.data.code == 200 && res.data.success) {
            this.policiesList = res.data.data.list;
            this.policiesList.forEach(item => {
              item.publishTime = utils.formattingDate(item.publishTime).second;
            });
          }
        });
      this.$http
        .getArticleDetail({ id: "580422b953f151650d30b62dab6cef7b" })
        .then(res => {
          if (res.data.code == 200 && res.data.success) {
            this.companyProfile = res.data.data;
          }
        });
    }
  },
  mounted() {
    this.getSupplyList();
    this.getRouteList();
    this.getCarList();
    this.getTableList();
    this.initbtn();
    this.getHomeInfo();
    this.getTableList();
    window.addEventListener("scroll", this.windowScroll);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    window.removeEventListener("scroll", this.windowScroll);
  },
  destroyed() {
    clearInterval(this.timer);
    window.removeEventListener("scroll", this.windowScroll);
  }
};
</script>
<style lang="less" scoped>
// 平台信息展示
.exhibition-company {
  display: flex;
  justify-content: space-between;
}
.show-item {
  width: 204px;
  height: 200px;
  text-align: center;
  .item-name {
    font-size: 18px;
    color: black;
    margin: 5px 0;
  }
  .item-number {
    .num {
      color: #e95732;
      font-size: 28px;
    }

    span {
      font-size: 18px;
      color: black;
    }
  }
}
.show {
  display: flex;
  height: 500px;
  .table {
    position: relative;
    width: 40%;
    height: 100%;
    margin-right: 5%;
    border: 1px solid #ccc;
    border-radius: 10px;
    .header {
      text-align: center;
      font-size: 22px;
    }
    .btn {
      display: flex;
      justify-content: space-around;
      padding-bottom: 6px;
      div {
        width: 60px;
        height: 34px;
        font-size: 14px;
        line-height: 34px;
        text-align: center;
        padding: 0 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        color: #959595;
        cursor: pointer;
        //点击按钮 时间过长会默认选中文本处理
        -moz-user-select: none; /*火狐*/
        -webkit-user-select: none; /*webkit浏览器*/
        -ms-user-select: none; /*IE10*/
        -khtml-user-select: none; /*早期浏览器*/
        user-select: none;
      }
      // 动态class
      .bg {
        background-color: #e95732;
        color: #fff;
      }
    }
    .roll {
      text-align: center;
      .tabletitle {
        display: flex;
        justify-content: space-around;
        font-size: 14px;
        p {
          width: 16.5%;
        }
      }
      .main {
        display: flex;
        justify-content: space-around;
        font-size: 14px;
        background-color: #eeeeee;
        margin-bottom: 2px;
        padding: 5px 0;
        span {
          width: 16.5%;
        }
      }
    }
  }

  // 滚动组件配置
  .seamless-warp {
    height: 280px;
    overflow: hidden;
  }
  // 地图
  .mapContainer {
    width: 55%;
    height: 100%;
    #map {
      width: 100%;
      height: 100%;
    }
  }
}
// 新闻模块
.policies,
.news {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.new-content {
  width: 1200px;
  margin: 40px auto 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  p {
    color: #989898;
    font-size: 16px;
    text-align: center;
    margin-bottom: 0px;
  }
  h3 {
    margin-top: 10px;
    color: #676767;
    text-align: center;
    font-size: 24px;
  }
  .content-item {
    width: 1200px;
    border: 1px solid #eee;
    background: #fff;
    min-height: 600px;
    padding: 20px;
    box-sizing: border-box;
    .el-col {
      min-height: 1px;
    }
    .customerNum {
      width: 100%;
      height: 120px;
      background: #6a8dae;
      border-radius: 10px;
      text-align: center;
      color: #fff;
      border: 1px solid #eee;
      box-shadow: 5px 5px #eee;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-left: 30px;
        width: 80px;
      }
      .num {
        font-size: 28px;
        line-height: 48px;
      }
    }
    .table {
      margin-top: 30px;
      .table-title {
        display: flex;
        justify-content: space-around;
        align-items: center;
        border-bottom: 1px solid #eee;
        & div {
          flex: 1;
          text-align: center;
          line-height: 60px;
          cursor: pointer;
          font-size: 20px;
        }
        .active {
          border-bottom: 3px solid #409eff;
          color: #409eff;
        }
      }
      ul {
        width: 800px;
        margin: 20px auto;
        list-style-type: none;
        li {
          line-height: 48px;
          font-size: 24px;
        }
        li:nth-child(1) {
          // color:gold;
          // font-style:italic;
          font-size: 30px;
        }
        li:nth-child(2) {
          // font-style:italic;
          font-size: 28px;
          // color: silver;
        }
        li:nth-child(3) {
          // font-style:italic;
          font-size: 26px;
          // color: goldenrod;
        }
      }
    }
  }
}

.content1 {
  width: 1200px;
  margin: 50px auto;
  .content-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #eeeeee;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .title {
    line-height: 60px;
    font-size: 18px;
    color: #333;
    font-weight: 600;
  }
}
</style>
